import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, unref as _unref } from "vue"

const _hoisted_1 = { id: "ManagePostView" }

import { onMounted, ref, watchEffect } from "vue";
import { Post, PostControllerService } from "../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";


export default /*@__PURE__*/_defineComponent({
  __name: 'ManagePostView',
  setup(__props) {

const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  pageSize: 10,
  current: 1,
});

const loadData = async () => {
  const res = await PostControllerService.listPostByPageUsingPost(
    searchParams.value
  );
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载数据失败！ " + res.message);
  }
};

onMounted(() => {
  loadData();
});
// 监听分页变量，改变时更新页面
watchEffect(() => {
  loadData();
});

const columns = [
  {
    title: "ID",
    dataIndex: "postId",
  },
  {
    title: "标题",
    dataIndex: "title",
  },
  {
    title: "标签",
    slotName: "tag",
  },
  {
    title: "创建时间",
    slotName: "createTime",
  },
  {
    title: "更新时间",
    slotName: "updateTime",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

const router = useRouter();
const doDelete = async (post: Post) => {
  const res = await PostControllerService.deletePostUsingPost({
    id: post.postId,
  });
  if (res.code === 0) {
    // 更新页面
    message.success("删除帖子成功！");
    await loadData();
  } else {
    message.error("删除帖子失败！ " + res.message);
  }
};
const toDetail = (post: Post) => {
  router.push({ path: `/view/post/${post.postId}` });
};
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input_number = _resolveComponent("a-input-number")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h1", null, "管理帖子", -1)),
    _createVNode(_component_a_table, {
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
      },
      onPageChange: onPageChange
    }, {
      tag: _withCtx(({ record }) => [
        _createVNode(_component_a_space, { wrap: "" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(record.tag), (item, index) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                key: index,
                color: "green"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 2
        }, 1024)
      ]),
      createTime: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      updateTime: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      userId: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(record.userId), 1)
          ]),
          _: 2
        }, 1024)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: ($event: any) => (toDetail(record))
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("查看帖子 ")
              ])),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_a_button, {
              status: "danger",
              onClick: ($event: any) => (doDelete(record))
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("删除")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"]),
    _createVNode(_component_a_space, null, {
      default: _withCtx(() => [
        _cache[3] || (_cache[3] = _createTextVNode("每页帖子数量 ")),
        _createVNode(_component_a_input_number, {
          modelValue: searchParams.value.pageSize,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.pageSize) = $event)),
          min: "1",
          placeholder: "每页帖子数量",
          size: "large"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})